/**
 * Created by zad on 17/4/26.
 */
import { put, call, takeLatest, select, takeEvery } from 'redux-saga/effects';
import { Notebooks, Trash } from '../constants/actionTypes';
import { getTrashNotesListState } from '../reducers/Trash/TrashNotesReducer';
import { getState } from '../reducers/Notebooks/NotebooksReducer';
import ajax from '../utils/ajax';

function* getNotebooksAsync(action) {
  const { isForce } = action;
  const notebooks = yield select(getState);
  try {
    if (notebooks.get('seq').size === 0 || isForce) {
      const { data } = yield call(ajax.getNotebooks);
      yield put({ type: Notebooks.GET_NOTEBOOKS_SUCCESS, data });
    } else {
      yield put({ type: Notebooks.GET_NOTEBOOKS_SUCCESS, isCache: true });
    }
  } catch (e) {
    yield put({ type: Notebooks.GET_NOTEBOOKS_FAIL });
  }
}

function* sortNotebooksAsync(action) {
  const { newSeq, oldSeq } = action;
  try {
    const { data } = yield call(ajax.sortNotebooks, newSeq);
    yield put({ type: Notebooks.SORT_NOTEBOOKS_SUCCESS });
  } catch (e) {
    yield put({ type: Notebooks.SORT_NOTEBOOKS_FAIL, oldSeq });
  }
}

function* newNoteBook(action) {
  const { name, resolve, reject } = action;
  try {
    const { data } = yield call(ajax.newNoteBook, name);
    yield put({ type: Notebooks.NEW_NOTEBOOK_SUCCESS, data });
    resolve(data);
  } catch (e) {
    yield put({ type: Notebooks.NEW_NOTEBOOK_FAIL });
    reject(e);
  }
}

function* deleteNoteBookSoft(action) {
  const { nbId, resolve, reject } = action;
  const trashList = yield select(getTrashNotesListState);

  try {
    const { data } = yield call(ajax.deleteNoteBookSoft, nbId);
    yield put({ type: Notebooks.DEL_NOTEBOOK_SOFT_SUCCESS, data, nbId });
    // 在已经有trashlist的情况下，文集删除成功意味着需要重新获取下trashlist
    if (trashList.get('seq')) {
      yield put({ type: Trash.GET_TRASH_NOTES_LIST, isForce: true });
    }
    resolve(data);
  } catch (e) {
    yield put({ type: Notebooks.DEL_NOTEBOOK_SOFT_FAIL, nbId });
    reject(e);
  }
}

// 重命名文集
function* renameNoteBook(action) {
  const { nbId, name } = action;
  try {
    const { data } = yield call(ajax.updateBookName, nbId, name);
    yield put({ type: Notebooks.RENAME_NOTEBOOK_SUCCESS, data, nbId, name });
  } catch (e) {
    yield put({ type: Notebooks.RENAME_NOTEBOOK_FAIL, nbId, name });
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* watchGetNotebooks() {
  yield takeEvery(Notebooks.GET_NOTEBOOKS, getNotebooksAsync);
}

export function* watchSortNotebooks() {
  yield takeLatest(Notebooks.SORT_NOTEBOOKS, sortNotebooksAsync);
}

export function* watchNewNoteBook() {
  yield takeEvery(Notebooks.NEW_NOTEBOOK, newNoteBook);
}

export function* watchDelNoteBookSoft() {
  yield takeLatest(Notebooks.DEL_NOTEBOOK_SOFT, deleteNoteBookSoft);
}

export function* watchRenameNoteBook() {
  yield takeLatest(Notebooks.RENAME_NOTEBOOK, renameNoteBook);
}



// WEBPACK FOOTER //
// ./src/sagas/NotebooksSaga.js